export enum SalesChannelType {
    NotSet = 0,
    BoxOffice = 1,
    Mobile = 2,
    Web = 3,
    Backstage = 4,
}



// WEBPACK FOOTER //
// ./src/app/models/sales-channel-type.enum.ts